/* JHSN swatches: klik op een swatch zet de verborgen themakiezer, het thema doet de rest.
   Op kaarten: hover wisselt het kaartbeeld naar die variant. */
(function () {
  if (window.__jhsnSw) return;
  window.__jhsnSw = true;
  function findTarget(el, id) {
    var sel = 'input[data-option-value-id="' + id + '"],option[data-option-value-id="' + id + '"]';
    for (var p = el.parentElement; p; p = p.parentElement) {
      var t = p.querySelector(sel);
      if (t) return t;
    }
    return null;
  }
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details.jhsn-sw__dd[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
    var b = e.target.closest('[data-jhsn-ov]');
    if (!b) return;
    e.preventDefault();
    var opt = b.closest('.jhsn-sw__opt');
    var id = b.getAttribute('data-jhsn-ov');
    opt.querySelectorAll('[data-jhsn-ov]').forEach(function (x) {
      var on = x === b;
      x.classList.toggle('is-selected', on);
      x.setAttribute(x.getAttribute('role') === 'option' ? 'aria-selected' : 'aria-checked', on ? 'true' : 'false');
    });
    var lab = opt.querySelector('[data-jhsn-selected]');
    if (lab) lab.textContent = b.getAttribute('data-jhsn-val');
    var pr = opt.querySelector('[data-jhsn-price]');
    if (pr && b.hasAttribute('data-jhsn-p')) pr.textContent = b.getAttribute('data-jhsn-p');
    var dd = b.closest('details');
    if (dd) dd.removeAttribute('open');
    var t = findTarget(b.closest('.jhsn-sw') || b, id);
    if (!t) return;
    if (t.tagName === 'OPTION') {
      var s = t.closest('select');
      if (s.value === t.value) return;
      s.value = t.value;
      s.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      if (t.checked) return;
      t.checked = true;
      t.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('.jhsn-swc__item[data-jhsn-img]');
    if (!a) return;
    var url = a.getAttribute('data-jhsn-img');
    for (var p = a.closest('.jhsn-swc').parentElement; p; p = p.parentElement) {
      var imgs = Array.prototype.filter.call(p.querySelectorAll('img'), function (i) { return !i.closest('.jhsn-swc'); });
      if (imgs.length) {
        imgs.forEach(function (i) { if (i.getAttribute('src') !== url) { i.removeAttribute('srcset'); i.setAttribute('src', url); } });
        return;
      }
    }
  });
})();
